import { Directive, ElementRef, HostListener, OnInit, Pipe, PipeTransform } from "@angular/core";
import { MatTooltip } from "@angular/material/tooltip";

@Directive({
  selector: '[matTooltip][appShowIfTruncated]'
})
export class ShowIfTruncatedDirective {
  constructor(
    private matTooltip: MatTooltip,
    private elementRef: ElementRef<HTMLElement>
  ) { }

  @HostListener('mouseenter', ['$event'])
  setTooltipState(e: MouseEvent) {
    const element = this.elementRef.nativeElement;
    this.matTooltip.disabled = element.scrollWidth <= element.clientWidth;
  }
}

@Pipe({ name: 'tooltipArrayToString' })
export class TooltipArrayToString implements PipeTransform {
  transform(value: string[], start: number, key: string): string {
    let str = "";
    for (let i = start; i < value.length; i++) {
      str += value[i][key] + ', ';
    }
    return str.slice(0, -2);
  }
}

/*
 *ngFor="let c of oneDimArray | sortBy:'asc'"
 *ngFor="let c of arrayOfObjects | sortBy:'asc':'propertyName'"
*/
import { orderBy } from 'lodash';

@Pipe({ name: 'sortBy' })
export class SortByPipe implements PipeTransform {

  transform(value: any[], order, column: string = ''): any[] {
    if (!value || order === '' || !order) { return value; } // no array
    if (value.length <= 1) { return value; } // array with only one item
    if (!column || column === '') {
      if (order === 'asc') { return value.sort() }
      else { return value.sort().reverse(); }
    } // sort 1d array
    return orderBy(value, [column], [order]);
  }
}